import { GridItem, GridRow } from "commons/ui/Grid";

type PropsType = { title?: string };

function AlertTitle({ title }: PropsType) {
    if (!title) {
        return null;
    }

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-10-10"}>
                    <h2 className={"dialog-title"}>{title}</h2>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default AlertTitle;
